module.exports = __webpack_public_path__ + "img/logo-dev-legacy.b7c4e23c.png";